import { useEffect, useState } from 'react';

/**
 * Seconds since the call connected, ticking once a second.
 *
 * Driven off answeredAt rather than an incrementing counter so it stays right
 * if the tab is backgrounded and the interval is throttled — and so the window
 * and the minimised pill, which each mount their own clock, always agree.
 */
const useCallClock = (answeredAt) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (!answeredAt) {
            setSeconds(0);
            return undefined;
        }
        const tick = () => setSeconds((Date.now() - answeredAt) / 1000);
        tick();
        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, [answeredAt]);

    return seconds;
};

export default useCallClock;
